import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from "react-scroll-up";
import { FiArrowDown, FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { FAQList } from "../component/common/CommonLists";
import consultant from "../assets/images/about/about-3.jpg";
import { Box, Typography } from "@mui/material";

class PrivacyPolicyChrome extends Component {
  render() {
    const faqData = FAQList;
    return (
      <React.Fragment>
        <PageHelmet pageTitle="Privacy Policy" />

        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        {/* Start Breadcrump Area */}
        <div
          className="rn-page-title-area pt--120 pb--190 bg_image bg_image--17"
          data-black-overlay="6"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rn-page-title text-center pt--100">
                  <h2 className="title theme-gradient">Privacy Policy</h2>
                  <h4>Chrome Extension</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Breadcrump Area */}

        {/* Start Contact Page Area  */}
        <div className="rn-contact-page ptb--120 bg_color--1">
          <div className="container">
            <div className="row row--35 align-items-start">
              <div className="col-lg-12 order-2 order-lg-1">
                <div className="section-title text-left mb--10">
                  <h2 className="title">Our Privacy Policy</h2>
                </div>
                <Box mt={3}>
                  <Typography variant="h6" gutterBottom>
                    Effective Date: 10-12-2024
                  </Typography>
                  <Typography paragraph>
                    LoanDeer Agent Connect ("the Extension") respects your
                    privacy. This document outlines what data is collected, how
                    it is used, and your rights as a user.
                  </Typography>

                  <Typography variant="h6" gutterBottom>
                    What We Collect:
                  </Typography>
                  <ul>
                    <li>Email and password credentials (via Firebase Auth)</li>
                    <li>Chrome extension usage (e.g., button clicks)</li>
                    <li>Message metadata (chat ID, agent ID, timestamps)</li>
                  </ul>

                  <Typography variant="h6" gutterBottom>
                    How We Use It:
                  </Typography>
                  <Typography paragraph>
                    We use the information we collect for the following
                    purposes:
                  </Typography>
                  <ul>
                    <li>To authenticate you securely as an agent</li>
                    <li>
                      To route live chat messages between you and site visitors
                    </li>
                    <li>To notify you of new leads and chat invitations</li>
                  </ul>

                  <Typography variant="h6" gutterBottom>
                    Data Sharing:
                  </Typography>
                  <ul>
                    <li>
                      Your data is <strong>not</strong> sold or shared with
                      third parties
                    </li>
                    <li>
                      All communication is encrypted using Google Firebase
                      security rules
                    </li>
                  </ul>

                  <Typography variant="h6" gutterBottom>
                    Storage:
                  </Typography>
                  <Typography paragraph>
                    All chat and login data is securely stored in Google
                    Firebase/Firestore
                  </Typography>

                  <Typography variant="h6" gutterBottom>
                    Your Rights
                  </Typography>
                  <ul>
                    <li>
                      You may request data removal by emailing
                      support@loandeer.com
                    </li>
                    <li>
                      You can revoke permissions or uninstall the extension at
                      any time
                    </li>
                  </ul>

                  <Typography variant="h6" gutterBottom>
                    Cookies and Tracking
                  </Typography>
                  <Typography paragraph>
                    Our website uses cookies to enhance your browsing experience
                    and gather usage data. You can manage your cookie
                    preferences through your browser settings.
                  </Typography>

                  <Typography variant="h6" gutterBottom>
                    Changes to This Policy
                  </Typography>
                  <Typography paragraph>
                    We may update this Privacy Policy periodically. Any changes
                    will be posted on this page with an updated effective date.
                  </Typography>

                  <Typography variant="h6" gutterBottom>
                    Contact Us
                  </Typography>
                  <Typography paragraph>
                    If you have questions about this Privacy Policy, contact us
                    at{" "}
                    <a href="mailto:support@LoanDeer.com">
                      support@LoanDeer.com
                    </a>
                    .
                  </Typography>
                </Box>
              </div>
            </div>
          </div>
        </div>
        {/* End Contact Page Area  */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}

        <Footer />
      </React.Fragment>
    );
  }
}
export default PrivacyPolicyChrome;
